////////////////////////////////////////////////Modal
if (!customElements.get('dl-js-modal')) {
  // モーダルの生成
  var ModalHtml = `
  <div class='dl-common__parts'>
    <div class='dl-js-modal'>
      <div class='dl-js-modal__wrap'>
        <div class='dl-js-modal__loading'><span></span></div>
        <dl-js-modal__close class='dl-js-modal__close__base'></dl-js-modal__close>
        <div class='dl-js-modal__content'>
          <dl-js-modal__close class='dl-js-modal__close__head'><span></span></dl-js-modal__close>
          <div class='dl-js-modal__content__wrap'>
          </div>
          <dl-js-modal__close class='dl-js-modal__close__foot'><span><span></span>CLOSE</span></dl-js-modal__close>
        </div>
      </div>
    </div>
  </div>
  `;

  document.querySelector('main').insertAdjacentHTML('afterend', ModalHtml);
  class DL_ModalClose extends HTMLElement {
    constructor() {
      super();
      this.addEventListener(
        "click",
        function () {
          document.body.style.overflow = "initial";
          DL_fadeOut(document.querySelector('.dl-js-modal'), 300, function () {
            for (var i = 0; i < document.querySelectorAll('dl-js-modal').length; i++) {
              document.querySelectorAll('dl-js-modal')[i].style.display = "none";
            }
            document.querySelector('.dl-js-modal__content').style.display = "none";
          });
        },
        false
      );

    }
  }

  customElements.define('dl-js-modal__close', DL_ModalClose);


  class DL_Modal extends HTMLElement {
    constructor() {
      super();
      const modal = this;
      document.querySelector('.dl-js-modal__content__wrap').appendChild(this);
      modal.name = modal.getAttribute("data-modal");
      modal.botton = document.querySelectorAll('.dl-js-modal__open[data-modal="' + modal.name + '"]');
      for (var i = 0; i < modal.botton.length; i++) {
        modal.botton[i].addEventListener(
          "click",
          function () {
            modal.open();
          },
          false
        );
      }
    }
    open() {
      const modal = this;
      if (document.querySelector('.dl-js-modal').style.display != "block") {
        DL_fadeIn(document.querySelector('.dl-js-modal'), 300, function () {
          document.body.style.overflow = "hidden";
          modal.style.display = "block";
          DL_fadeIn(document.querySelector('.dl-js-modal__content'), 400);
        });
      } else {
        DL_fadeOut(document.querySelector('.dl-js-modal__content'), 300, function () {
          for (var i = 0; i < document.querySelectorAll('dl-js-modal').length; i++) {
            document.querySelectorAll('dl-js-modal')[i].style.display = "none";
          }
          modal.style.display = "block";
          DL_fadeIn(document.querySelector('.dl-js-modal__content'), 300)
        });
      }

    }
  }
  customElements.define('dl-js-modal', DL_Modal);
}
